/**
 * Resource Vuex
 */

import * as API from "@/endpoints";
import Axios from "axios";
import Vue from "vue";
import User from "@/store/modules/user";
import _ from "lodash";
import { userInfo } from "os";
import Cons from '@/constants.json'

export default {
  namespaced: true,
  state: {
    documents: {
      data: {},
      isLoading: false,
      isDeleting: false
    },
    singleResource: {
      data: {},
      cancelInvitationLoader: false,
      attendees: {},
      isLoadingAttendees: false,
      subscribers: {},
      isLoadingSubscribers: false,
      isLoading: false,
      volunteerLoader: false,
      subscribeLoader: false,
      searchLoader: false,
      sendInvitationLoader: false,
      pendingVolunteerLoader: false,
      groupInvites: {},
      pendingVolunteer: {},
      groupRemoveLoader: false,
      permissionLoader: false
    },
    groupFeed: {
      list: {},
      isLoading: false,
      isLoadingItems: false
    },
    resources: {
      groups: {
        data: {},
        isLoading: false
      },
      special_project: {
        data: {},
        isLoading: false
      },
      extras: {},
      discover: {},
      submenu: {}
    },
    pendingResources: {
      list: {
        data: []
      },
      isLoading : false,
      isDeleteLoading: false,
      isApproveLoading: false
    }
  },
  getters: {
    moduleDocs: (state) => {
      return state.documents.data;
    },
    isLoadingDocs: (state) => {
        return state.documents.isLoading;
    },
    isGroupFeedLoading(state){
      return state.groupFeed.isLoading
    },
    resourceLoading: (state) => {
      return state.singleResource.isLoading
    }
  },
  mutations: {
    pushItemToResourceGroupFeed(state, v){
      if (state.groupFeed.list.careplan_item)
        state.groupFeed.list.careplan_item.push(v)
    },
    setCancelInvitationLoader (state, v) {
      Vue.set(state.singleResource, "cancelInvitationLoader", v);
    },
    setUserGroupFeedMore (state, v) {
      state.groupFeed.list.next_link = v.next_link;
      for (var x = 0; x < v.careplan_item.length; x++) {
        state.groupFeed.list.careplan_item.push(v.careplan_item[x]);
      }
    },
    setUserpendingResourcesMore (state, v) {
      state.pendingResources.list.next_link = v.next_link;
      for (var x = 0; x < v.data.length; x++) {
        state.pendingResources.list.careplan_item.push(v.data[x]);
      }
    },
    setMoreSubscribers (state, v) {
      state.singleResource.subscribers.next_link = v.next_link;
      for (var x = 0; x < v.subscribers.length; x++) {
        state.singleResource.subscribers.subscribers.push(v.subscribers[x]);
      }
    },
    setMoreAttendees (state, v) {
      state.singleResource.attendees.next_link = v.next_link;
      for (var x = 0; x < v.attendees.length; x++) {
        state.singleResource.attendees.attendees.push(v.attendees[x]);
      }
    },
    setUserGroupFeed(state, v) {
      Vue.set(state.groupFeed, "list", v);
    },
    setUserGroupFeedLoader(state, v) {
      Vue.set(state.groupFeed, "isLoading", v);
    },
    setGroupFeedItemLoader(state, v) {
      Vue.set(state.groupFeed, "isLoadingItems", v);
    },
    setSingleGroupSubscribers(state, v) {
      Vue.set(state.singleResource, "subscribers", v);
    },
    setSingleGroupSubscribersLoader(state, v) {
      Vue.set(state.singleResource, "isLoadingSubscribers", v);
    },
    setSingleGroupAttendees(state, v) {
      Vue.set(state.singleResource, "attendees", v);
    },
    setSingleGroupAttendeesLoader(state, v) {
      Vue.set(state.singleResource, "isLoadingAttendees", v);
    },
    setSingleGroup(state, v) {
      Vue.set(state.singleResource, "data", v);
    },
    setSingleGroupLoader(state, v) {
      Vue.set(state.singleResource, "isLoading", v);
    },
    setResource(state, v) {
      if (v.type === "groups") Vue.set(state.resources.groups, "data", v.data);
    },
    setResourceLoader(state, v) {
      if (v.type === "groups")
        Vue.set(state.resources.groups, "isLoading", v.data);
    },
    setAddResource(state, v) {
      if (v.type === "groups") {
        for (var x = 0; x < v.data.careplan.length; x++) {
          state.resources.groups.data.careplan.push(v.data.careplan[x]);
        }
      }
    },
    addSingleResourceData(state, v) {
      state.resource.groupFeed.list.careplan_item.push(v);
    },
    removeItem(state, v) {
      let foundInStack = state.groupFeed.list.careplan_item.findIndex( (i) => {
        return i.id === v
      });
      if(foundInStack != -1){
        state.groupFeed.list.careplan_item.splice(foundInStack,1);        
      }
    },
    setVolunteerLoader(state, v) {
      Vue.set(state.singleResource, "volunteerLoader", v);
    },
    pushUserStuffs(state, v) {
      console.log(v)
      if (!_.isEmpty(User.state.userStuffs.careplans))
        User.state.userStuffs.careplans.unshift(v);
    },
    removeUserStuffs(state, v) {
      if (!_.isEmpty(User.state.userStuffs.careplans)) {
        for (let i = 0; i < User.state.userStuffs.careplans.length; i++) {
          if (User.state.userStuffs.careplans[i].careplan_id == v) {
            User.state.userStuffs.careplans.splice(i, 1);
          }
        }
      }
    },
    updateGroupSubscribeStatus(state, v) {
      Vue.set(state.singleResource.data, "subscribed", v);
    },
    updateEventSubscribeStatus(state, v) {
      Vue.set(state.singleResource.data, "status", v);
    },
    updateEventSubscribeInviteId(state, v) {
      Vue.set(state.singleResource.data, "invite_id", v);
    },
    subscribeLoader(state, v) {
      Vue.set(state.singleResource, "subscribeLoader", v);
    },
    searchLoader(state, v) {
      Vue.set(state.singleResource, "searchLoader", v);
    },
    sendInvitationLoader(state, v){
      Vue.set(state.singleResource, "sendInvitationLoader", v)
    },
    setPendingInvites(state, v){
      Vue.set(state.singleResource, "groupInvites", v)
    },
    setPendingVolunteer(state, v){
      Vue.set(state.singleResource, "pendingVolunteer", v)
    },
    setPendingVolunteerLoader(state, v){
      Vue.set(state.singleResource, "pendingVolunteerLoader", v)
    },
    setPendingResources(state, v){
      // Vue.set(state.pendingResources, 'list' , v)
      Vue.set(state.pendingResources.list, 'careplan_item' , v.careplan_item)
    },
    deletePendingItem(state, v) {
      let foundInStack = state.pendingResources.list.careplan_item.findIndex( (i) => {
        return i.id === v
      });
      if(foundInStack != -1){
        state.pendingResources.list.careplan_item.splice(foundInStack,1);        
      }
    },
    addResourceData(state, v) {
      let foundInStack = state.groupFeed.list.careplan_item.find( (i) => {
        return i.id === v.id
      });
      if( !foundInStack ) state.groupFeed.list.careplan_item.unshift(v);
    },
    setPendingResourcesLoading(state, v){
      Vue.set(state.pendingResources, 'isLoading' , v)
    },
    setPendingResourcesApproveLoading(state, v){
      Vue.set(state.pendingResources, 'isApproveLoading' , v)
    },    
    setPendingResourcesDeleteLoading(state, v){
      Vue.set(state.pendingResources, 'isDeleteLoading' , v)
    },
    removeGroupInvitation(state, v){
      for (let i=0; i<state.singleResource.groupInvites.length; i++){
        if(state.singleResource.groupInvites[i].id == v){
          state.singleResource.groupInvites.splice(i, 1);
        }
      }
    },
    removeVolunteerInvitaion(state, v){
      for (let i=0; i<state.singleResource.pendingVolunteer.careplan_item.length; i++){
        if(state.singleResource.pendingVolunteer.careplan_item[i].id == v){
          state.singleResource.pendingVolunteer.careplan_item.splice(i, 1);
        }
      }
    },
    pushGroupInvite(state, v) {
      if (!_.isEmpty(state.singleResource.groupInvites))
        state.singleResource.groupInvites.unshift(v);
    },
    setGroupRemoveLoader(state, v){
      Vue.set(state.singleResource, "groupRemoveLoader", v);
    },
    removeStuff(state, v){
      for (let i=0; i<User.state.userStuffs.careplans.length; i++){
        if(User.state.userStuffs.careplans[i].careplan){
          if(User.state.userStuffs.careplans[i].careplan_id == v){
            User.state.userStuffs.careplans.splice(i, 1);
          }
        }else{
          if(User.state.userStuffs.careplans[i].id == v){
            User.state.userStuffs.careplans.splice(i, 1);
          }
        }
      }
    },
    setPermissionLoader(state, v) {
      Vue.set(state.singleResource, "permissionLoader", v);
    },
    updateGroupPermission(state, v) {
      // Vue.set(state.singleResource.subscribers, "subscribed", v);
      for(let i = 0; i < state.singleResource.subscribers.subscribers.length; i++){
        if(state.singleResource.subscribers.subscribers[i].id == v.user_id){
          Vue.set(state.singleResource.subscribers.subscribers[i], "careplan_permission", v);
          break;
        }
      }
    },
    setExtras(state, v) {
      Vue.set(state.resources, 'extras', v)
    },
    setDiscover(state, v) {
      Vue.set(state.resources, 'discover', v)
    },
    setSubmenu(state, v) {
      Vue.set(state.resources, 'submenu', v)
    }
  },
  actions: {
    loadMoreFollowers({ commit, dispatch }, { url }) {
      commit("setSingleGroupSubscribersLoader", true);
      return new Promise((resolve, reject) => {
        Axios.get(url).then(
          res => {
            commit("setMoreSubscribers", res.data);
            commit("setSingleGroupSubscribersLoader", false);
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            commit("setSingleGroupSubscribersLoader", false);
            reject(error);
          }
        );
      });
    },
    loadMoreAttendees({ commit, dispatch }, { url }) {
      commit("setSingleGroupAttendeesLoader", true);
      return new Promise((resolve, reject) => {
        Axios.get(url).then(
          res => {
            var subs = []
            let finalRes;
            res.data.data.forEach(function(child) {
              let dt = child.data.user
              subs.push(dt)
            });
            finalRes = {
              page:res.data.page,
              per_page:res.data.per_page,
              total:res.data.total,
              prev_link:res.data.prev_link,
              next_link:res.data.next_link,
              subscribers:subs,
            }
            commit("setMoreAttendees", res.data);
            commit("setSingleGroupAttendeesLoader", false);
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            commit("setSingleGroupAttendeesLoader", false);
            reject(error);
          }
        );
      });
    },
    getSingleResourceSubscribers({ commit, dispatch }, { id }) {
      return new Promise((resolve, reject) => {
        commit("setSingleGroupSubscribersLoader", true);
        commit("setSingleGroupSubscribers", []);
        Axios.get(
          API.endpoints.careplan + "/" + id + "/subscribers?sort_by=latest"
        ).then(
          res => {
            commit("setSingleGroupSubscribers", res.data);
            commit("setSingleGroupSubscribersLoader", false);
            resolve(res.data);
          },
          error => {
            commit("setSingleGroupSubscribersLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    getSingleResourceAttendees({ commit, dispatch }, { id }) {
      return new Promise((resolve, reject) => {
      commit("setSingleGroupAttendeesLoader", true);
        Axios.get(
          API.endpoints.event + "/" + id + "/invites?sort_by=updated_at&asc=0&filter=status:accepted"
        ).then(
          res => {
            var subs = []
            let finalRes;
            res.data.data.forEach(function(child) {
              let dt = child.data.user
              subs.push(dt)
            });
            finalRes = {
              page:res.data.page,
              per_page:res.data.per_page,
              total:res.data.total,
              prev_link:res.data.prev_link,
              next_link:res.data.next_link,
              subscribers:subs,
            }
            commit("setSingleGroupAttendeesLoader", false);
            commit("setSingleGroupAttendees", finalRes);
            resolve(res.data);
          },
          error => {
            commit("setSingleGroupAttendeesLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    getSingleResourceAttendees2({ commit, dispatch }, { id }) {
      return new Promise((resolve, reject) => {
      commit("setSingleGroupAttendeesLoader", true);
        Axios.get(
          API.endpoints.event + "/" + id + "/subscribers"
        ).then(
          res => {
            res.data.subscribers = res.data.data
            commit("setSingleGroupAttendees",res.data);
            commit("setSingleGroupAttendeesLoader", false);
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            commit("setSingleGroupAttendeesLoader", false);
            reject(error);
          }
        );
      });
    },
    searchFollowers({ commit, dispatch }, payload) {
      commit("searchLoader", true);
      return new Promise((resolve, reject) => {
        Axios.get(
          API.endpoints.careplan +
            "/" +
            payload.id +
            "/subscribers?sort_by=latest&search=" +
            payload.search
        ).then(
          res => {
            commit("setSingleGroupSubscribers", res.data);
            commit("searchLoader", false);
            resolve(res.data);
          },
          error => {
            commit("searchLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    getSingleResourceModule({ commit, dispatch, state, rootGetters }, { id }) {
        return new Promise((resolve, reject) => {
          commit("setUserGroupFeedLoader", true);
          commit("setSingleGroupLoader", true);

          let story = rootGetters["brand/getSelectedStory"]

          Axios.get(API.endpoints.base + "module/" + id + '?user_story_id='+story.id+'&include_hidden=0&brand_id=' + Cons[0].BRAND_ID, {headers:{"Cache-control":"no-cache"}}).then(
            res => {
              console.log("I AM HERE: ", res.data.documents);
              commit("library/setDocuments", res.data.documents ? res.data.documents : [], {root:1});
              commit("setSingleGroup", res.data);
              dispatch("getSingleResourceSubscribers", { id });
              commit("setUserGroupFeedLoader", false);
              commit("setSingleGroupLoader", false);
              resolve(res.data);
            },
            error => {
              commit("setUserGroupFeedLoader", false);
              commit("setSingleGroupLoader", false);
              dispatch("exceptionHandling", { _err: error }, { root: 1 });
              reject(error);
            }
          );
        });
    },
    getSingleResource({ commit, dispatch, state }, { id }) {
      // if (id !== state.singleResource.data.id) {
        return new Promise((resolve, reject) => {
          commit("setSingleGroupLoader", true);
        commit("setUserGroupFeedLoader", true);
          Axios.get(API.endpoints.careplan + "/" + id, {headers:{"Cache-control":"no-cache"}}).then(
            res => {
              commit("setUserGroupFeedLoader", false);
              commit("setSingleGroup", res.data);
              dispatch("getSingleResourceSubscribers", { id });
              commit("setSingleGroupLoader", false);
              resolve(res.data);
            },
            error => {
              commit("setUserGroupFeedLoader", false);
              dispatch("exceptionHandling", { _err: error }, { root: 1 });
              commit("setSingleGroupLoader", false);
              reject(error);
            }
          );
        });
      // }
    },
    getSingleEvents ({ commit, dispatch, state }, {id}) {
      return new Promise((resolve, reject) => {
        commit("setSingleGroupLoader", true);
        Axios.get(API.endpoints.mainbrand + '/1/event/' + id, {headers:{"Cache-control":"no-cache"}}).then(res => {
          commit('setSingleGroup', res.data)
          dispatch("getSingleResourceAttendees2", { id });
          commit("setSingleGroupLoader", false);
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          commit("setSingleGroupLoader", false);
          reject(error)
        })
      })
    },
    getResource({ commit, dispatch }, { type, query }) {
      return new Promise((resolve, reject) => {
        commit("setResourceLoader", { type, data: true });
        Axios.get(API.endpoints.brand + "/developed/careplan?" + query).then(
          res => {
            commit("setResource", { type, data: res.data });
            commit("setResourceLoader", { type, data: false });
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            commit("setResourceLoader", { type, data: false });
            reject(error);
          }
        );
      });
    },
    getResourceNextPage({ commit, dispatch }, { type, url }) {
      return new Promise((resolve, reject) => {
        commit("setResourceLoader", { type, data: true });
        Axios.get(url).then(
          res => {
            commit("setAddResource", { type, data: res.data });
            commit("setResourceLoader", { type, data: false });
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            commit("setResourceLoader", { type, data: false });
            reject(error);
          }
        );
      });
    },
    getGroupFeedMore({ commit, dispatch }, { url }) {
      commit("setUserGroupFeedLoader", true);
      return new Promise((resolve, reject) => {
        Axios.get(url).then(
          res => {
            commit("setUserGroupFeedMore", res.data);
            commit("setUserGroupFeedLoader", false);
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            commit("setUserGroupFeedLoader", false);
            reject(error);
          }
        );
      });
    },
    getPendingResourcesMore({ commit, dispatch }, { url }) {        
      commit("setPendingResourcesLoading", true);
      return new Promise((resolve, reject) => {
        Axios.get(url).then(
          res => {
            commit("setUserpendingResourcesMore", res.data);
            commit("setPendingResourcesLoading", false);
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            commit("setPendingResourcesLoading", false);
            reject(error);
          }
        );
      });
    },
    getGroupFeed({ commit, dispatch, state }, { planId }) {
      return new Promise((resolve, reject) => {
        commit("setUserGroupFeedLoader", true);
        commit("setGroupFeedItemLoader", true);
        commit("base/setLoadingPage", true, {root: 1});
        Axios.get(
          API.endpoints.careplan +
            "/" +
            planId +
            "/item?asc=0&sort_by=rrule_parsed_date&day=0&exclude_type=event_membership&start_date=" +
             new Date().toISOString().substr(0, 10) +"&direction=down"
        ).then(
          res => {
          commit("setGroupFeedItemLoader", false);
          commit("setUserGroupFeedLoader", false);
            commit("base/setLoadingPage", false, {root: 1});
            commit("setUserGroupFeed", res.data);
            resolve(res.data);
          },
          error => {
          commit("setGroupFeedItemLoader", false);
          commit("setUserGroupFeedLoader", false);
            commit("base/setLoadingPage", false, {root: 1});
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    updateGroupInfo({ commit, dispatch, state }, payload) {
      commit("setSingleGroupLoader", true);
      return new Promise((resolve, reject) => {
        Axios.put(API.endpoints.careplan + "/" + payload.id, payload.data).then(
          res => {
            commit("setSingleGroup", res.data);
            resolve(res.data);
            commit("setSingleGroupLoader", false);
          },
          error => {
            commit("setSingleGroupLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    postUpdateVolunteer({ commit, dispatch, state }, payload) {
      commit("setVolunteerLoader", true);
      return new Promise((resolve, reject) => {
        Axios.post(
          API.endpoints.careplan + "/" + payload.id + "/item",
          payload.data
        ).then(
          res => {
            // commit('addSingleResourceData', res.data);
            resolve(res.data);
            commit("setVolunteerLoader", false);
          },
          error => {
            commit("setVolunteerLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    getSingleActivityOnly({ commit, dispatch, state }, payload) {
      commit("setVolunteerLoader", true);
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.base + "item/" + payload)
          .then(
            res => {
              resolve(res.data);
            },
            error => {
              commit("setVolunteerLoader", false);
              dispatch("exceptionHandling", { _err: error }, { root: 1 });
              reject(error);
            }
          );
      });
    },
    createGroup({ commit, dispatch, state }, payload) {
      commit("setResourceLoader", { type: "groups", data: true });
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.careplan, payload).then(
          res => {
            commit('pushUserStuffs', res.data);
            commit("setResourceLoader", { type: "groups", data: false });
            resolve(res.data);
          },
          error => {
            commit("setResourceLoader", { type: "groups", data: false });
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    followGroup({ commit, dispatch, state }, payload) {
      commit("subscribeLoader", true);
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.careplan + "/prescribe", payload, {headers:{"Cache-control":"no-cache"}}).then(
          res => {
            commit("updateGroupSubscribeStatus", true);
            commit("subscribeLoader", false);
            commit("pushUserStuffs", res.data);
            
            // DO THE POINTS
            dispatch("points/setUserActionPoints", {
              action: "join_group",
              module_id: payload.careplan_id
            }, {root: 1})
            
            resolve(res.data);
          },
          error => {
            commit("subscribeLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    unfollowGroup({ commit, dispatch, state }, payload) {
      commit("subscribeLoader", true);
      return new Promise((resolve, reject) => {
        Axios.delete(
          API.endpoints.careplan + "/" + payload + "/unsubscribe"
        ).then(
          res => {
            commit('updateEventSubscribeStatus', null)
            commit("updateGroupSubscribeStatus", false);
            commit("subscribeLoader", false);
            commit("removeUserStuffs", payload);
            resolve(res.data);
          },
          error => {
            commit("subscribeLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    sendInvitation({ commit, dispatch, state }, payload) {
      commit("sendInvitationLoader", true);
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.careplan + "/prescribe", payload).then(
          res => {
            commit("pushGroupInvite", res.data);
            commit("sendInvitationLoader", false);
            resolve(res.data);
          },
          error => {
            commit("sendInvitationLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    getPendingGroupInvites({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + "/" + payload + "/pending/prescription").then(
          res => {
            commit("setPendingInvites", res.data);
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    getPendingInviteVolunteer({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + "/" + payload + "/item?type=apply_volunteer&filter=status:pending;").then(
          res => {
            commit("setPendingVolunteer", res.data);
            resolve(res.data);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    acceptPendingVolunteer({ commit, dispatch, state }, payload) {
      commit("setPendingVolunteerLoader", true);
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.volunteer + "/application/" + payload.id + "/accept", payload.permission).then(
          res => {
            commit("setPendingVolunteerLoader", false);
            commit("removeVolunteerInvitaion", payload.id);
            resolve(res.data);
          },
          error => {
            commit("setPendingVolunteerLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    cancelInvitation({ commit, dispatch, state }, payload){
      return new Promise((resolve, reject) => {
        commit("setCancelInvitationLoader", true);
        Axios.delete(API.endpoints.careplan + "/" + payload + "/remove").then(
          res => {
            commit("removeGroupInvitation", payload);
            resolve(res.data);
            commit("setCancelInvitationLoader", false);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
            commit("setCancelInvitationLoader", false);
          }
        )
      });
    },
    followBrandGroup({ commit, dispatch}, {group, userId, type}) {
      commit("setPendingVolunteerLoader", true);
      return new Promise((resolve, reject) => {
        if(type === 'follow') {
          Axios.post(API.endpoints.base + '/follow/user/' + group.developed_by, null, {headers: {'Cache-control':'no-cache'}}).then(
            res => {
              resolve(res.data);
            },
            error => {
              dispatch("exceptionHandling", { _err: error }, { root: 1 });
              reject(error);
            }
          )
        } else {
          Axios.delete(API.endpoints.base + '/unfollow/user/' + group.developed_by).then(
            res => {
              resolve(res.data);
            },
            error => {
              dispatch("exceptionHandling", { _err: error }, { root: 1 });
              reject(error);
            }
          )
        }

      });
    },
    removeGroup({ commit, dispatch, state }, payload){
      commit('setGroupRemoveLoader', true);
      return new Promise((resolve, reject) => {
        Axios.delete(API.endpoints.careplan + "/" + payload).then(
          res => {
            commit('removeStuff', payload)
            commit('setGroupRemoveLoader', false);
            resolve(res.data);
          },
          error => {
            commit('setGroupRemoveLoader', false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    updateUserPermission({ commit, dispatch, state }, payload){
      commit('setPermissionLoader', true);
      return new Promise((resolve, reject) => {
        Axios.put(API.endpoints.careplan + '/' + payload.careplan_id + '/permission/' + payload.permission_id, payload).then(
          res => {
            console.log(res)
            commit('setPermissionLoader', false);
            commit('updateGroupPermission', res.data)
            resolve(res.data);
          },
          error => {
            commit('setPermissionLoader', false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    addUserPermission({ commit, dispatch, state }, payload) {
      commit('setPermissionLoader', true);
      return new Promise((resolve, reject) => {
        Axios.post(API.endpoints.careplan + '/' + payload.careplan_id + '/permission', payload).then(
          res => {
            console.log(res)
            commit('setPermissionLoader', false);
            commit('updateGroupPermission', res.data)
            resolve(res.data);
          },
          error => {
            commit('setPermissionLoader', false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        )
      });
    },
    getDiscover({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        console.log("GET DISCOVER")
        // Axios.get(API.endpoints.careplan + '/' + Cons[0].GROUP_ID.discover).then(
        console.log(API.endpoints.base + 'discover/items/' + Cons[0].BRAND_ID)
        Axios.get(API.endpoints.base + 'discover/items/' + Cons[0].BRAND_ID).then(
          res => {
            commit('setDiscover', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 });
            reject(error)
          }
        )
      })
    },
    getSubmenu({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + payload).then(
          res => {
            commit('setSubmenu', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 });
            reject(error)
          }
        )
      })
    },    
    getExtrass ({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.careplan + '/' + Cons[0].GROUP_ID.extras).then(
          res => {
            commit('setExtras', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 });
            reject(error)
          }
        )
      })
    },
    removeUserFromGroup({commit,dispatch,state}, {userId,groupId}){
      return new Promise((resolve,reject)=>{
        Axios.delete(API.endpoints.join,{params:{user_id:userId, group_id: groupId}}).then(
          res =>{
            resolve(res.data)
          },
          error =>{
            reject(error)
          }
        )
      })
    },
    getPendingResource({ commit, dispatch }, careplan_id) {
      return new Promise((resolve, reject) => {
        commit("setPendingResourcesLoading", true);
        Axios.get(API.endpoints.careplan + "/" + careplan_id + "/items/pending").then(
          res => {
            commit("setPendingResourcesLoading", false);
            commit("setPendingResources", res.data);
            resolve(res.data);
          },
          error => {
            commit("setPendingResourcesLoading", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    removePendingItem({ commit, dispatch }, careplan_id) {
      return new Promise((resolve, reject) => {
        commit("setPendingResourcesDeleteLoading", true);
        Axios.post(API.endpoints.activities + "/delete/pending",{item_id:careplan_id}).then(
          res => {
            commit("deletePendingItem", careplan_id);
            commit("setPendingResourcesDeleteLoading", false);
            resolve(res.data);
          },
          error => {
            commit("setPendingResourcesDeleteLoading", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    approvePendingItem({ commit, dispatch }, item) {
      return new Promise((resolve, reject) => {
        commit("setPendingResourcesApproveLoading", true);
        Axios.post(API.endpoints.activities + "/approved/pending",{item_id:item.id}).then(
          res => {
            commit("addResourceData", item);
            commit("user/addUserResources", item,{ root: true });
            commit("setPendingResourcesApproveLoading", false);
            resolve(res.data);
          },
          error => {
            commit("setPendingResourcesApproveLoading", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    getModuleDocs({context, state}, payload) {
      let url = API.endpoints.careplan + '/' + payload + '/item?filter=module_attachment_type:additional_documents&sort_by=order&asc=1'
      return new Promise((resolve, reject) => {
          state.documents.isLoading = true;
          Axios.get(url)
              .then(res => {
                console.log('getModuleDocs', res.data);
                
                state.documents.isLoading = false;
                state.documents.data = res.data;
                resolve(res.data)
              })
              .catch(err => {
                  state.documents.isLoading = false;
                  reject(err)
              })
      })
    }
  }
};
